module.exports = __webpack_public_path__ + "static/IMG_6176.0983c381.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/IMG_6176.png
// module id = 439
// module chunks = 168707334958949